import React, { Component } from 'react';
import _ from 'lodash';

class InteractBottomFixed extends Component {

    constructor(props) {
        super(props);

        this.state = {
            date: this.customDateString(new Date()),//new Date().toLocaleDateString(),
            time: new Date().toLocaleString('en-US', { hour: 'numeric',minute:'numeric', hour12: true })
        }
        this._timeInterval = null;
    }

    componentDidMount() {
        this._timeInterval = setInterval(() => {
            this.tickTime();
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this._timeInterval);
        this._timeInterval = null;
    }

    customDateString = (date) => {
        let monthNumber = String(date.getMonth()+1);
        let fullYear = String(date.getFullYear());
        let day = String(date.getDate());  
        return monthNumber+'/'+day+'/'+fullYear; 
    }
    
    tickTime = () => {
        this.setState({
            date: this.customDateString(new Date()),//new Date().toLocaleDateString().replace(/-0+/g, '-'),
            time: new Date().toLocaleString('en-US', { hour: 'numeric',minute:'numeric', hour12: true })
        })
    }

    render(){
      return (
        <div style={{ position: 'fixed', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10, bottom: 0 }}>
                <div style={{ display: 'flex', alignItems: "center", width: this.props.screen.r16_9.width, height: '100%' }}>
                <span style={{ 
                    textAlign: 'center',
                    position: 'absolute', 
                    top: this.props.screen.r16_9.p10 * .51,
                    width: this.props.screen.r16_9.p10 * 2, 
                    left: this.props.screen.r16_9.width - this.props.screen.r16_9.p10*3, 
                    fontFamily: 'Ostrich', 
                    fontSize: this.props.screen.r16_9.p10 * .32, 
                    color: '#496778' }}>
                    {this.state.date}
                </span>
                <span style={{ 
                    textAlign: 'center',
                    position: 'absolute', 
                    top: this.props.screen.r16_9.p10 * .21,
                    width: this.props.screen.r16_9.p10 * 2, 
                    left: this.props.screen.r16_9.width - this.props.screen.r16_9.p10*3, 
                    fontFamily: 'Ostrich', 
                    fontSize: this.props.screen.r16_9.p10 * .32, 
                    color: '#496778' }}>
                    {this.state.time}
                </span>
                </div>
        </div>
      )
    }
  }

export default InteractBottomFixed



// WEBPACK FOOTER //
// ./src/Components/Navigation/InteractBottomFixed.js